import * as daHelper from '../dialogActionsHelper';
import {dialogsNames} from '../../../enums/dialogsNames';
import * as cassettesService from '../../../services/Cassettes/cassettesService';
import Network from 'infrastructure/js/modules/network';
import {api as printLabelsApi} from '../../PrintLabelsActions/printLabelsActions';


const config = {
  getSubmitMethod: () => cassettesService.slitRollsToCassettes,
};

export const actionTypes = {
  ...daHelper.getActionTypes(dialogsNames.SLIT_ROLLS_TO_CASSETTES),
};

const actions = {
  ...daHelper.getActions(dialogsNames.SLIT_ROLLS_TO_CASSETTES),

};

export let api = {
  ...daHelper.getApiActions(actions, config),

  generateCassetteId (dispatch, getState) {
    return function () {
      return cassettesService.generateCassetteId().then((response) => {
        if (!Network.isResponseValid(response)) {
          console.error('Generate Cassette Id failed', response);
          return { success: false };
        }
        return response.data;
      });
    };
  },

  autoGenerateCassettes (dispatch, getState) {
    return function (data) {
      return cassettesService.autoGenerateCassettesIds(data).then((response) => {
        if (!Network.isResponseValid(response)) {
          console.error('Auto Generate Cassettes Ids failed', response);
          return { success: false };
        }
        return response.data;
      });
    };
  }
}

export let jsxActions = {
  ...daHelper.getJsxActions(api),

  generateCassetteId() {
    return function (dispatch, getState) {
      return api.generateCassetteId(dispatch, getState)();
    };
  },

  autoGenerateCassettes(data) {
    return function (dispatch, getState) {
      return api.autoGenerateCassettes(dispatch, getState)(data);
    };
  },

  submit(data, messageDialogBuilder, reloadParentComponent, printPDFLabels = false) {
    return function (dispatch, getState) {
      api.submit(dispatch, getState)(data, messageDialogBuilder, reloadParentComponent)
        .then((response) => {

          const { statusType } = response?.applicationResponseStatus ?? {};
          if (statusType === 'OK' && printPDFLabels) {
            const assetsIds = response.dataList
              ?.filter(item => item?.applicationResponseStatus?.statusType === 'OK')
              ?.map(item => item.data?.id) ?? [];
            return printLabelsApi.printMultiAssetsLabels(dispatch, getState)(assetsIds);
          }
        })
    };
  },

};
